module.exports = __webpack_public_path__ + "img/buque-de-flores.a2ad938a.png";